import { render, staticRenderFns } from "./StepsPF.vue?vue&type=template&id=288c5529&scoped=true&"
import script from "./StepsPF.vue?vue&type=script&lang=js&"
export * from "./StepsPF.vue?vue&type=script&lang=js&"
import style0 from "./StepsPF.vue?vue&type=style&index=0&id=288c5529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c5529",
  null
  
)

export default component.exports